export default Object({
  // WEB_API_PATH: "https://localhost:5001/api/",
  // WEB_TOKEN_PATH: "https://localhost:5001/Token",
  // WEB_HUB_PATH: "https://localhost:5001/SignalR",

  // WEB_API_PATH: "http://192.168.21.246:8041/api/",
  // WEB_TOKEN_PATH: "http://192.168.21.246:8041/Token",
  // WEB_HUB_PATH: "http://192.168.21.246:8041/SignalR",

  // WEB_API_PATH: "https://192.168.21.11:8020/POApplication/api/",
  // WEB_TOKEN_PATH: "https://192.168.21.11:8020/POApplication/Token",
  // WEB_HUB_PATH: "https://192.168.21.11:8020/POApplication/SignalR",

  // WEB_API_PATH: "https://192.168.21.246:8041/api/",
  // WEB_TOKEN_PATH: "https://192.168.21.246:8041/Token",
  // WEB_HUB_PATH: "https://192.168.21.246:8041/SignalR",

  // WEB_API_PATH: "https://localhost:5001/api/",
  // WEB_TOKEN_PATH: "https://localhost:5001/Token",
  // WEB_HUB_PATH: "https://localhost:5001/SignalR",

  // WEB_API_PATH: "/api/",
  // WEB_TOKEN_PATH: "/Token",
  // WEB_HUB_PATH: "/SignalR",

  WEB_API_PATH: "/POApplication/api/",
  WEB_TOKEN_PATH: "/POApplication/Token",
  WEB_HUB_PATH: "/POApplication/SignalR",

  // WEB_API_PATH: "https://erp.nibmindia.org/POApplication/api/",
  // WEB_TOKEN_PATH: "https://erp.nibmindia.org/POApplication/Token",
  // WEB_HUB_PATH: "https://erp.nibmindia.org/POApplication/SignalR",

  LOG_Token: "bearer ".concat(window.sessionStorage.getItem("token")),
  AF_Token: window.sessionStorage.getItem("antiforgery_token")
});



// WEBPACK FOOTER //
// ./src/router/globalConfig.js